<template>
  <div class="wrapper">
	   <headerTag />
       <div class="detailCon1">
		  <img src="../../assets/images/detail/fpsl.png" alt=""  />
	   </div>
	   <div class="detailCon1-div1 clear">
	   			  <p>
	   				  <span>发票申领</span>
	   				  <span v-if="productPrice=='my'">
	   				  		面议
	   				  </span>
	   				  <span v-else>
	   				  		￥{{productPrice}}
	   				  </span>
	   			  </p>
	   			  <p>        
	   				专员快速介入,帮助解决问题。
	   			  </p>
	   			  <p @click="areaChoose">
	   				  地区：
	   				 <span>
	   					 <b>{{preProv}}</b>
	   					 -<b>{{preCity}}</b>
	   					 </span>
	   				  <i></i>
	   			  </p>
	    </div>
	 
	  <div class="detailCon detailCon3">
	  	  <p class="detailCon2-tips" style="margin-top: 0;">
	  		 服务简介
	  	   </p>
		   
		   <p>
				为有开票需求的客户提供一站式税务开票服务，凡需向税务机关申请开具发票的单位或个人，均应提供发生购销业务、接受服务或者经营活动的书面证明，对税法规定应当缴纳税款的，税务机关应当在开票同时征税。 
				<br>需要注明发票申领类型是增值税专用发票、货物运输业增值税专用发票或者通用机打发票。
				                                 
			</p>
	   </div>
	  <div class="detailCon detailCon4">
	   	  <p class="detailCon2-tips" style="margin-top: 0;">
	   		 服务流程
	   	   </p>
	   	   <p>
			   <span>
				   <img src="../../assets/images/detail/liucheng1.png" alt="" />
				   <i>咨询下单</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng2.png" alt="" />
			   		<i>提交材料</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng3.png" alt="" />
			   		<i>业务办理</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng4.png" alt="" />
			   		<i>售后服务</i>
			   </span>
		   </p>
	    </div>
	  <div class="detailCon detailCon5">
			  <p class="detailCon2-tips" style="margin-top: 0;">
				 所需材料
			   </p>
			  <div>
				  <p><i></i><span>身份证明原件及复印件</span></p>
				  <p><i></i><span>发票申领的具体需求及说明</span></p>
			  </div>
	  </div>
		 
		<div class="detailBottom-box">
			<div class="detailBottom">
				<p @click="runQq()">
					<i>
						<img src="../../assets/images/detail/QQ.png" alt="" style="height: 1.23rem;" />
					</i>
					
					<span>QQ联系</span>
				</p>
				<p @click="runWx()">
					<i>
						<img src="../../assets/images/detail/weixin.png" alt="" style="height: 1rem;" />
					</i>
					<span>微信联系</span>
				</p>
				<p>
					<a :href="'tel:'+phoneNum">
						<i>
							<img src="../../assets/images/detail/phone.png" alt="" style="height: 0.92rem;" />
						</i>
						<span>电话联系</span>
					</a>
				</p>
				<button @click="buyThis" v-bind:disable="dis" :class="{'cur': dis == true}">{{buyBtn}}</button>
			</div>
		</div>
	 
		<van-popup v-model="areaShow" position="bottom"><!-- :style="{height:'20%'}" -->
			<van-picker
				v-show="provShow"
				show-toolbar
				@cancel="areaShow = false"
			    :columns="provinceName"
			    @confirm="provChoose"
			  />
			  <van-picker
				  v-show="cityShow"
			  	 show-toolbar
			      :columns="cityName"
			      @cancel="onlyProv"
			      @confirm="cityChoose"
			    />
		</van-popup>
		
		<van-popup v-model="wxShow" class="popDiv erDiv">
				<p>
					<span>扫码咨询</span>
					<img src="../../assets/images/detail/close.png" class="closeImg" @click="wxShow=false" />
				</p>
				<img :src="wxPic" class="erImg" />
				<p class="wxTitle">
					<i></i>
					<span>微信号</span>
					<i></i>
				</p>
				<p class="erNum" id="copyValue">{{wxNum}}</p>
				<p class="copyBtn">
					<button @click="copy" data-agl-cvt="32" id="copyTxt" data-clipboard-action="copy" data-clipboard-target="#copyValue">复制</button>
				</p>
				<p class="wxTips">扫一扫或复制微信号，添加好友咨询~</p>
		</van-popup>
   </div>
</template>

<script>
  import "../../assets/css/detail.scss"
  import headerTag from '@/components/headerTag/headerTag.vue'
  import { getProductDetail,getProv,getCity,getCustomerInfo,openConsult,nowBuyProduct } from '../../assets/js/common.js' 
  import { myMixin } from '../../mixins' 
  import { Popup,Picker } from 'vant'
  import Clipboard from 'clipboard'
 
  export default {
    name: 'productFpsl',
	mixins:[myMixin],
	props:{
		
	},
	data(){
		return {
			bussFlag:8,
			areaShow:true,
			isShow:0,
			provinceNum:3,  //省份编码
			cityNum:37,  //城市编码
			areaShow:false,  //地区选择弹框
			provShow:true,  //省份选择弹框
			cityShow:false, //城市选择弹框
			preProv:'上海市',   //当前选中的省份名
			preCity:'上海市',  //当前选中的城市名
			wxShow:false,//微信弹框
			dis:false, //立即购买按钮的disable
			buyBtn:'立即购买',
			areaName:'上海市-上海市',
		}
	},
	components: {
       headerTag,
	   [Popup.name]:Popup,
	   [Picker.name]:Picker ,
     },
	 methods:{
		 buyThis(){
		 	let _this=this;
		 	if(this.pid == null || this.pid == "" ){
			  	_this.$message.error({message: "暂无产品，请咨询客服"});
			  	return;
		    }
		    _this.dis=true; // 不可点击
			nowBuyProduct(this.pid,function(data){
				_this.dis=false;
				if(data.code == 1000){
					//成功
					window.location.href='/order/paySure/'+data.obj;
				}else if(data.code == 1110){
					//未登录
					let currPath=window.location.href;
					window.location.href='/login?targetUrl='+currPath;
				}else{
					_this.$message.error({message: errorback});
				}
			},(errorback)=>{
				_this.dis=false;
				_this.$message.error({message: errorback});
			})
			
		 }, 
		areaChoose(){
			this.areaShow=true;
		},
		provChoose(preProv){
			this.pid='';
			this.preProv = preProv;
			this.preCity="";
			this.cityNum='';
			this.provShow=false;
			this.cityShow=true;
			for(var i=0;i<this.provinceName.length;i++){
				if(preProv==this.provinceName[i]){
					this.provinceNum = this.provinceCode[i]
					let _this = this
					getCity(this.provinceCode[i],function(cityCode1,cityName1){
						_this.cityName = cityName1;
						_this.cityCode = cityCode1;
					},()=>{
						this.$message.error({message: '网络异常，请稍后重试'});
					})
				}
			}
		},
		onlyProv(){
			this.areaShow=false;
			this.preCity='';
			this.productPrice='my';
			
			this.dis=true;
			this.buyBtn="请咨询客服";
			this.provShow=true;
			this.cityShow=false;
		},
		cityChoose(preCity){
			this.preCity = preCity;
			for(var i=0;i<this.cityName.length;i++){
				if(preCity==this.cityName[i]){
					this.cityNum = this.cityCode[i]
				}
			}
			this.provSure = this.preCity;
			this.areaShow=false;
			this.provShow=true;
			this.cityShow=false;
			this.getProductInfo(this.bussFlag);
		},
		
		
		getProductInfo(){
			if(this.cityNum=='' || this.cityNum==null){
			 this.$message.error({message: '请选择城市'});
			}
			this.axios({
			    method: 'POST',
			    url:'/product/getProductInfo',
				params:{
					bussFlag:this.bussFlag,
					provinceNum:this.provinceNum,
					cityNum:this.cityNum,
					companyType:this.gsType,
					companyQuaType:this.nsType,
					areaChoose:this.dzType,
					bankType:this.khType,
				},
			}).then((res)=>{
					if(res.data.code==1000){
						
						this.productPrice = res.data.obj.price;
						this.pid = res.data.obj.pid;
						this.dis=false;
						this.buyBtn="立即购买";
						
					}else if(res.data.code==1002){
						this.pid=null;
						this.productPrice='my';
						this.dis=true;
						this.buyBtn="请咨询客服";
					}
			}).catch((err)=>{
				 this.$message.error({message: '获取数据失败'});
			})
		},
		
		runQq(){//QQ联系
			openConsult(this.qqNum);
		},
		runWx(){//微信联系
			if(this.wxNum==null){
				this.wxShow=false;
				this.$message('该业务员暂无微信');
			}else{
				this.wxShow=true;
			}
		},
		copy(){
			var clipboard = new Clipboard('#copyTxt', {
			    text: function () {
			        //return $('#copyValue').text();
			    }
			});
					
			clipboard.on('success', e => {  
				this.$message.success({message: '已复制成功，快去微信添加好友吧~~',customClass:'mzindex'});
				// 释放内存  
				clipboard.destroy()  
			})  
			clipboard.on('error', e => {  
				  // 不支持复制 
				   this.$message.error({message: '抱歉哦，复制失败请手动复制微信号~~',customClass:'mzindex'});
				  // 释放内存  
				  clipboard.destroy()  
			})  
			       
		},
	 },
	 created() {
		 let _this = this;
		getProductDetail(8,this.$route.params.pid,function(data){ //产品信息
			if(data.obj == "" || data.obj == null){
				_this.productPrice='my';
				_this.dis=true;
				_this.buyBtn="请咨询客服";
			}else{
				_this.pid = data.obj.pid; //产品ID
				_this.productPrice=data.obj.price;//产品价格
				_this.bussFlag= data.obj.bussFlag; 
				_this.nsType=data.obj.qualificationType;  //纳税资质
				_this.serverTerm=data.obj.serverTerm;//服务周期
				
				_this.provinceNum=data.obj.provinceNum; //省份编码
				_this.cityNum=data.obj.cityNum; //城市编码
				
				_this.areaName=data.obj.areaName; //地区名称
				var arr = _this.areaName.split('-');
				_this.preProv=arr[0];
				_this.preCity=arr[1];
			}
		},(errorback)=>{
			_this.$message.error({message: errorback});
		})
		
		getProv(function(proName,proCode){//省份
			_this.provinceName = proName;
			_this.provinceCode = proCode;
			
		},()=>{
			this.$message.error({message: '网络异常，请稍后重试'});
		})
		
		getCustomerInfo(function(data){//业务员信息
			_this.qqNum=data.qq;
			_this.wxNum=data.wx;
			_this.phoneNum=data.phone;
			_this.wxPic=_this.rootUrl+data.wxPic;
		},()=>{
			_this.$message.error({message: '网络异常，请稍后重试'});
		})
	 },
   }
</script>